export default {
  pages: {
    offerDemandsShow: {
      goToOfflineItems: "Oflayn tovarga o'tish",
    },
  },
};
